import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";

interface FeatureToggleResponse {
	featureActivated: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class FeatureToggleService {
	private subRoute = "featureToggle";
	constructor(private http: HttpClient) { }

	featureSerialNumberEnable(subDivision: number): Observable<boolean> {
		const URL = environment.backend_Jab_url + this.subRoute + `/serialNumber`;
		return this.http.get<{ featureActived: boolean }>(URL, { params: { subDivision: subDivision } })
			.pipe(
				map(response => response.featureActived)
			);
	}

	checkAutomaticPickingHandHeldToggle(subDivisionUidK: number): Observable<boolean> {
		const parametersEnumName = 'ENABLE_AUTOMATIC_PICKING_HAND_HELD';
		const URL = environment.backend_url + "/api/v1/" + this.subRoute;
		return this.http.get<FeatureToggleResponse>(URL, {
			params: {
				subDivisionUidK: subDivisionUidK.toString(),
				parametersEnum: parametersEnumName
			}
		}).pipe(
			map(response => response.featureActivated)
		);
	}
}
